import React, { useState } from "react";
import { Dialog } from "@mui/material";
import SubmitLumpSumReimbursementRequest from "./SubmitLumpSumReimbursementRequest";
import { CaseWhenBenefit } from "services/GraphQl";
import WhenBenefitLumpSumTracker from "./LumpSumBenefitTracker";

interface LumpSumBenefitSummaryProps {
  whenBenefit: CaseWhenBenefit;
  hasBankAccount: boolean;
  setBankAccountModalOpen: (open: boolean) => void;
  companyId: string;
  caseId: string;
  onReimbursementSubmitted?: () => void;
}

const LumpSumBenefitSummary: React.FC<LumpSumBenefitSummaryProps> = ({
  whenBenefit,
  hasBankAccount,
  companyId,
  setBankAccountModalOpen,
  caseId,
  onReimbursementSubmitted,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (whenBenefit?.distributionType !== "LUMP_SUM") return null;

  return (
    <>
      <WhenBenefitLumpSumTracker whenBenefit={whenBenefit} setModalOpen={setModalOpen} />
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <SubmitLumpSumReimbursementRequest
          hasBankAccount={hasBankAccount}
          whenBenefit={whenBenefit}
          companyId={companyId}
          caseId={caseId}
          onSave={() => {
            setModalOpen(false);
            onReimbursementSubmitted?.();
            setBankAccountModalOpen(true);
          }}
          onCancel={() => setModalOpen(false)}
        />
      </Dialog>
    </>
  );
};

export default LumpSumBenefitSummary;
